module.exports = __webpack_public_path__ + "static/media/bebe5.18e3f939.jpg";